import React, { useState } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import {
  useFirebase,
  firestore,
} from "../../../components/firebase/FirebaseProvider";
import Typography from "@material-ui/core/Typography";
import { useDocumentData } from "react-firebase-hooks/firestore";
import currency from "../../../utils/currency";
import useStyles from "./style/style";
import Gap from "../../../components/Gap";

const CardAccumulate = ({ data }) => {
  const { user } = useFirebase();

  const userAccumulateRef = firestore.doc(
    `users/${user?.uid}/products_campaigns/${data?.id}`
  );

  const [userAccumulate, loadingUserAccumulate] = useDocumentData(
    userAccumulateRef,
    { idField: "id" }
  );

  const nilai_sales_accumulation = userAccumulate?.sales_accumulation
    ? userAccumulate?.sales_accumulation
    : 0;

  const newData = data?.rewards.find(
    (e) => e?.target > nilai_sales_accumulation
  );

  return (
    <>
      <div
        style={{
          marginLeft: "5px",
        }}
      >
        <Typography variant="body1" style={{ color: "#fff" }}>
          {data?.campaign_name}
        </Typography>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "5px",
        }}
      >
        {nilai_sales_accumulation > 0 ? (
          <>
            <Typography
              variant="caption"
              style={{ color: "#fff", marginRight: "5px" }}
            >
              Penjualanmu sudah
            </Typography>
            <Typography
              variant="body2"
              style={{ color: "#fff", marginRight: "5px" }}
            >
              {currency(userAccumulate?.sales_accumulation)}
            </Typography>
          </>
        ) : (
          <Typography
            variant="caption"
            style={{ color: "#fff", marginRight: "5px" }}
          >
            Belum ada penjualan
          </Typography>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "5px",
        }}
      >
        {newData !== undefined ? (
          <>
            <Typography
              variant="caption"
              style={{ color: "#fff", marginRight: "4px" }}
            >
              Ayo jualan
            </Typography>
            <Typography
              variant="body2"
              style={{ color: "#fff", marginRight: "4px" }}
            >
              {currency(newData?.target - nilai_sales_accumulation)}
            </Typography>
            <Typography
              variant="caption"
              style={{ color: "#fff", marginRight: "4px" }}
            >
              lagi, untuk nabung {newData?.name}
            </Typography>
          </>
        ) : (
          <Typography variant="caption" style={{ color: "#fff" }}>
            Ayo segera tukarkan, hubungi cs tokorame
          </Typography>
        )}
      </div>
      <Gap height={10} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#B5BABE",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        {loadingUserAccumulate
          ? "loading.."
          : data?.rewards?.map((item) => {
              const bgColor =
                nilai_sales_accumulation >= Number(item.target)
                  ? "#E0B802"
                  : "#B5BABE";
              const bdRadius =
                nilai_sales_accumulation == Number(item.target) ? 10 : 0;

              return (
                <div
                  style={{
                    backgroundColor: bgColor,
                    borderTopRightRadius: bdRadius,
                    borderBottomRightRadius: bdRadius,
                    flex: data?.rewards?.length <= 1 ? 1 : 1 / 2,
                    textAlign: "center",
                  }}
                >
                  <Typography variant="caption">{item.name}</Typography>
                </div>
              );
            })}
      </div>
    </>
  );
};

function CounAccumulation() {
  const classes = useStyles();
  const { products_campaigns } = useData();

  return (
    products_campaigns.length > 0 && (
      <>
        <Gap height={15} />
        <div>
          <div
            style={{
              background:
                "linear-gradient(180deg, rgba(59,72,191,100) 0%, rgba(84,142,240,100) 100%)",
              borderRadius: "10px",
              padding: "10px",
              color: "#fff",
              position: "relative",
            }}
          >
            <div className={classes.containerGarisImg}>
              <img
                className={classes.imgGaris}
                src="https://firebasestorage.googleapis.com/v0/b/sommerce-develop.appspot.com/o/utils%2FFrame%202608208.png?alt=media&token=1e9b7ba3-ff64-47cd-aa68-eace71e408aa"
              />
            </div>
            {products_campaigns?.map((item) => {
              return (
                <div style={{ position: "relative", zIndex: "99" }}>
                  <CardAccumulate data={item} />
                </div>
              );
            })}
          </div>
        </div>
      </>
    )
  );
}

export default CounAccumulation;
